
































import { Component, Vue } from 'vue-property-decorator'
import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { ReferralStatus } from '@/api/types'
import { v4 as uuid } from 'uuid'

@Component
export default class RealworksStatusRuleCreate extends Vue {
    realworksStatusRule: RealworksStatusRule = null
    loading: boolean = false

    async mounted() {
        this.loading = true
        this.createNewRealworksStatusRule()
        this.loading = false
    }

    createNewRealworksStatusRule() {
        this.realworksStatusRule = new RealworksStatusRule(
            uuid(),
            this.$currentCompany,
            [],
            null,
            null,
            [],
            null,
            [],
            null,
            [],
            [],
            [],
            null,
            [],
            this.$currentCompany.pipelinesEnabled ? ReferralStatus.OPEN : null,
            null,
            null,
            null,
            false,
            '',
            true,
            true,
            true,
            2,
            new Date(),
            new Date(),
        )
    }

    async goBackToLister(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_virtual_colleague_realworks_status_rules',
        })
    }
}
